import {z} from 'zod';
import {tradeDbSchema} from './tradeDbSchema';
import {tradeMessageSchema} from './tradeMessageSchema';

/** Parsed trade document: `exitPrice === 0` or `closedAt === 0` means position open; `profitLoss === 0` means P/L not set. */
export const tradeSchema = tradeDbSchema
  .omit({
    messages: true,
  })
  .extend({
    id: z.string(),
    messages: tradeMessageSchema.array().default([]),
  });

export interface Trade extends z.infer<typeof tradeSchema> {}
